import { Box, Button, ButtonProps, TextareaAutosize, TextField } from "@mui/material";
import { styled, Theme } from "@mui/material/styles";
import EndTimePicker from "../../components/EndTimePIcker";
import StartTimePicker from "../../components/StartTimePicker";

export const styles = (theme: Theme) => ({
    root: {
        margin: '32px 20px',
        padding: '18px',
    },
    gridContent: {
        padding: 10,
    },
    secondGridContainer: {
        border: '1px solid #ccc',
        left: 'auto',
        height: '91vh',
    },
    productDetailsItem: {
        // width: '70%',
    },
    proceedToCheckout: {
        color: 'white',
        width: '60%',
        borderRadius: '50px',
        backgroundColor: theme.palette.secondary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main
        }
    },
    modifyProduct: {
        textDecoration: 'none',
        fontSize: '18px',
        paddingLeft: '8px',
        cursor: 'pointer',
        color: 'white',
        backgroundColor: '#121212',
    },
    cartEmpty: {
        height: '30vh',
        background: "url('/static/images/shopping-bag-empty.png') no-repeat center center",
        color: '#000000',
        backgroundSize: '',
        overflow: 'hidden'
    },
    cartIteamElement: {
        fontSize: '12px'
    },
    marginBottom20PX: {
        marginBottom: '20px',
    },
    totalPriceContainer: {
        padding: 5,
    },
    marginBottom5: {
        marginBottom: '5px'
    },
    fullWidth: {
        width: '100%',
    },
    productTotalPrice: {
        'text-align': 'right',
    },
    cartHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '15px 0px 10px',
        minHeight: '52px',
    },
    orderTitle: {
        fontSize: '15px',
        fontWeight: 700,
        marginBottom: '5px',
    },
    title: {
        fontSize: '15px',
        fontWeight: 700,
    },
    orderTitleRight: {
        fontSize: '15px',
        fontWeight: 700,
        marginBottom: '5px',
        textAlign: 'right' as 'right',
    },
    couponContainer: {
        display: 'flex',
        marginTop: 15,
    },
    couponContainerMobile: {
        display: 'flex',
    },
    couponField: {
        marginTop: 2,
        maxWidth: 170,
    },
    couponFieldInput: {
        '& input': {
            padding: '5px 10px 0px',
            fontSize: 15,
        },
    },
    couponButton: {
        minWidth: 'initial',
        margin: '2px 0px 0px 5px',
        padding: '3px 0px 0px',
        fontSize: 14,
        height: 22,
        width: 53,
    },
    couponError: {
        color: theme.palette.error.main,
        margin: '2px 9px 0',
    },
    couponErrorMobile: {
        color: theme.palette.error.main,
        margin: '9px 9px 5px',
    },
    textareaBoxSize: {
        minWidth: '100%',
        maxWidth: '100%',
        border: '2px solid #cccc'
    },
    orderTotal: {
        'text-align': 'right',
    },
    paymentDialog: {
    },
    dialogTitle: {
        padding: 0,
        height: '25px',
    },

    iframeRoot: {
        backgroundColor: '#fff',
        border: 'none',
        minHeight: '850px',
        // marginTop: '-5px',
        width: '100%',
        overflowY: 'auto',
        "@media (max-width: 432px)": {
            // width: 'calc(100vw - 95px)',
            height: 'calc(var(--vh, 1vh) * 100 - 350px)',
            // marginTop: '20px',
            minHeight: 0,
        },
        "@media only screen and (min-width: 768px)": {
            width: '100%',
            // height: '72vh',
            marginTop: '-15px',
            minHeight: 'calc(80vh - 64px)',
        },
    },
    dialogContent: {
        padding: 0,
        "@media (min-width: 1200px)": {
            display: 'flex',
            justifyContent: 'center',
        },
        "@media (min-width: 768px)": {
            display: 'flex',
            justifyContent: 'center',
        },
    },
    closeButton: {
        padding: 0,
    },
    label: {
        paddingLeft: '42px',
        fontSize: '20px',
    },
    scheduleDetails: {
        display: 'flex',
        // paddingLeft: '42px',
        [theme.breakpoints.down('xs')]: {
            display: 'inline-block',
        },
    },
    datetimeField: {
        minWidth: '225px',
        marginRight: '20px',
        [theme.breakpoints.down('xs')]: {
            paddingBottom: '10px',
        },
    },
    detetimeFieldInput: {
        color: theme.palette.error.main,
    },
    deliveryTime: {
        minWidth: 181,
    },
    keyboardButtonProps: {
        color: '#000',
    },
    orderMessage: {
        textAlign: 'center' as 'center',
        margin: '5px auto',
        maxWidth: 912,
        color: theme.palette.error.main,
        fontSize: 23,
        padding: 15,
        borderRadius: 15,
        backgroundColor: '#dcdcdc',
    },
    selectedDateErrorMessage: {
        color: theme.palette.error.main,
        margin: '2px auto',
        fontSize: 18,
        textAlign: 'center' as 'center',
    },
    deleteButton: {
        color: '#000000',
    },
    companyLogo: {
        maxHeight: 40,
        maxWidth: 109,
        backgroundColor: '#f3f3f6',
    },
    deliveryNote: {
        marginBottom: 20,
    },
    formControlLabel: {
        paddingTop: '5px'
    },
    expansionPanel: {
        background: 'initial',
        border: 'none',
        boxShadow: 'none',
        paddingBottom: 15,
        '&::before': {
            content: 'none',
        },
    },
    expansionPanelSummary: {
        padding: 0,
        maxWidth: 'fit-content',
        justifyContent: 'start',
        color: '#0000ef',
    },
    expansionPanelSummarySubtitle: {
        marginBottom: 0,
    },
    expansionArrow: {
        color: '#242424',
        padding: 0,
        marginLeft: -10,
        fontSize: 30,
    },
    expansionPanelContent: {
        padding: 0,
    },
    itemNotesContainer: {
        textAlign: 'left' as 'left',
    },
    itemNotes: {
        fontSize: 18,
        textTransform: 'none' as 'none',
    },
    errorMessage: {
        color: '#ff0000',
        fontSize: '16px',
        paddingRight: '10px',
        marginLeft: 8,
        transition: '1s',
        opacity: 0,
        marginTop: 3,
    },
    qtyErrorMessageActive: {
        opacity: 1,
    },
    subtitle: {
        marginTop: 15,
    },
    cartScrollablePanel: {
        maxHeight: 450,
        overflowY: 'auto' as 'auto',
        overflowX: 'hidden' as 'hidden',
        paddingBottom: 10,
        // "@media screen and (max-width: 1366px)": {
        //     maxHeight: 550,
        // },
        // "@media screen and (min-width: 1920px)": {
        //     maxHeight: 600,
        // },
    },
    qtyDropdown: {
        padding: 0,
        margin: '0 !important',
        fontSize: '18px !important',
        '& > div': {
            fontSize: '18px',
        },
    },
    dropdownOptions: {
        fontSize: '18px',
    },
});

export const CustomScrollbarBox = styled(Box)({
    maxHeight: '260px',
    overflowY: 'auto',
    width: '100%',
    padding: '12px',
    '&::-webkit-scrollbar': {
      width: '0.3em'
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)'
    }
  });

export const StyledTextField = styled(TextField)({
    '& fieldset': {
        borderRadius: '8px',
    },
    '& .MuiInputBase-input': { 
        fontSize: '18px',
    },
    '& .MuiFormLabel-root': {
        fontSize: '18px',
    },
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
        fontSize: '18px',
    },
});

export const StyledStartTimePicker = styled(StartTimePicker)({
    '& fieldset': {
        borderRadius: '8px',
    },
    '& .MuiInputBase-input': { 
        fontSize: '18px',
    },
    '& .MuiFormLabel-root': {
        fontSize: '18px',
    },
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
        fontSize: '18px',
    },
});

export const StyledEndTimePicker = styled(EndTimePicker)({
    '& fieldset': {
        borderRadius: '8px',
    },
    '& .MuiInputBase-input': { 
        fontSize: '18px',
    },
    '& .MuiFormLabel-root': {
        fontSize: '18px',
    },
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
        fontSize: '18px',
    },
});

export const StyledTextareaAutosize = styled(TextareaAutosize)(
    ({ theme }) => `
    border-radius: 8px;
    padding: 10px 10px;
  `,
);

export const StyledPayButton = styled(Button)({
    textTransform: 'none',
    padding: '16px',
    width: '100%',
    height: '100%',
    minWidth: '50%',
    borderRadius: '12px',
});

export const OrderTypeButton = styled(Button)<ButtonProps>(() => ({
    minWidth: '100px',
    width: '140px',
    color: '#000000',
    borderRadius: '16px',
    textTransform: 'none',
    padding: '24px 20px',
    cursor: 'pointer',
}));